module.exports = __webpack_public_path__ + "img/366.4498f9e4.jpg";